import React from 'react';

export interface ListItemProps {
  /**
   * Content of the list item
   */
  children: React.ReactNode;
  /**
   * Custom CSS classes
   */
  className?: string;
  /**
   * Inline styles
   */
  style?: React.CSSProperties;
  /**
   * HTML id attribute
   */
  id?: string;
  /**
   * Click event handler
   */
  onClick?: (event: React.MouseEvent<HTMLLIElement>) => void;
  /**
   * ARIA label
   */
  'aria-label'?: string;
  /**
   * ARIA described by
   */
  'aria-describedby'?: string;
  /**
   * ARIA current (for navigation items)
   */
  'aria-current'?: 'page' | 'step' | 'location' | 'date' | 'time' | 'true' | 'false';
}

export const ListItem: React.FC<ListItemProps> = ({
  children,
  className = '',
  style,
  id,
  onClick,
  'aria-label': ariaLabel,
  'aria-describedby': ariaDescribedby,
  'aria-current': ariaCurrent,
}) => {
  const baseClass = 'hi-ui-list-item';
  const allClasses = `${baseClass} ${className}`.trim();

  return (
    <li
      className={allClasses}
      style={style}
      id={id}
      onClick={onClick}
      aria-label={ariaLabel}
      aria-describedby={ariaDescribedby}
      aria-current={ariaCurrent}
    >
      {children}
    </li>
  );
};
